import Vue from 'vue'
import Vuex from 'vuex'
import LetItSnow from 'vue-let-it-snow';

Vue.use(Vuex)
Vue.use(LetItSnow)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
